import { Empty } from "antd";
import styled from "styled-components";

export const EmptyDataTableWrapper = styled(Empty)`
  .ant-empty-description {
    font-weight: var(--font-medium);
    color: var(--color-text-secondary);
  }
`;
